// extracted by mini-css-extract-plugin
export default {"container":"_389XfCP7r6hhgqfsBoGRC5","loading":"psZ-HIAe34CqvwLuKzYsx","subtitle":"_3zuug8dGrYA-s3l-rV7GG-","description":"_1UqBxMGtSuwLf_0_GLn0H2"};